module.exports = __webpack_public_path__ + "media/images/athletes/3444-3bb77dcbfa56f0eb1553eca99b942824.png";